import { PMSs } from 'main/hotelBrandsAndChains'

export const userEmailsRestartPMS = [
  'sinan@swaypay.io',
  'sinan@directful.com',
  'sevket@swaypay.io',
  'sevket@directful.com',
  'sevket01@sevder.com',
  'gurjeet.singh@directful.com'
]

export const userEmailsCanMarkInviteAsPaid = [
  'sevket01@sevder.com',
  'sevket@swaypay.io',
  'sevket@directful.com',
  'gizem.erdeniz@directful.com',
  'vishal.raval@directful.com',
  'huseyin.kartal@directful.com',
  'jane@directful.com',
  'oguzhan.aydin@directful.com',
  'nikhil@directful.com',
  'murat@directful.com',
  'wesley.estacio@directful.com',
  'bruno.silva@directful.com',
  'david.oliveira@directful.com',
  'jocelyn.fernandez@directful.com'
]

export const userEmailsCanAlwaysRegisterCampaign = ['gizem.erdeniz@directful.com']

export const userEmailsCanToggleUserDefaultOperaReports = [
  'sinan@swaypay.io',
  'sinan@directful.com',
  'sevket01@sevder.com',
  'sevket@swaypay.io',
  'sevket@directful.com'
]

export const PMSsWithSyncLoginSupport = [
  PMSs.choiceadvantage,
  PMSs.skytouch,
  PMSs.webrezpro,
  PMSs.visualmatrix,
  PMSs.roomkey,
  PMSs.resnexus,
  PMSs.ohip,
  PMSs.jonaschorum,
  PMSs.marriottgxp,
  PMSs.clock,
  PMSs.maestro,
  PMSs.infor,
  PMSs.cloudbeds,
  PMSs.destiworld,
  PMSs.synxis,
  PMSs.mews,
  PMSs.hotelkey,
  PMSs.stayntouchapi
]

export const PMSsCanSwitchToOhip = [PMSs.opera, PMSs.operadefault]
